module.exports = __webpack_public_path__ + "media/spinner-wheel-celebration.89c51ecc.mp3";